import React from "react";
import { useTranslation } from "react-i18next";

const SelectType = (props) => {

    const { type, setType, limitedList, barebones } = props;

    const { t } = useTranslation();

    const types = limitedList || [
        "Acceptable Use Policy",
        "Accessibility Statement",
        "Advertising Agreement",
        "Anti-Spam Policy",
        "Arbitration Agreement",
        "Artwork Release Agreement",
        "Asset Purchase Agreement",
        "Assignment Agreement",
        "Bill of Sale",
        "CCPA Statement",
        "Clean Team Agreement",
        "Commercial Rental Agreement",
        "Commission Agreement",
        "Commodity Sales Agreement",
        "Confidentiality Agreement",
        "Consignment Agreement",
        "Construction Contract",
        "Consulting Agreement",
        "Cookie Policy",
        "Copyright Agreement",
        "Copyright License",
        "Copyright Notice",
        "Data Retention Policy",
        "Debt Settlement Agreement",
        "Deed of Assignment",
        "Deed of Trust",
        "Deferred Compensation Agreement",
        "Disclaimer",
        "Distribution Agreement",
        "Employee Non-Compete Agreement",
        "Employee Non-Disclosure Agreement",
        "Employment Contract",
        "Employment Separation Agreement",
        "End User License Agreement",
        "Environmental Policy Statement",
        "Equipment Lease Agreement",
        "Exclusivity Agreement",
        "Facility Use Agreement",
        "Fair Use Policy",
        "Financial Disclosure Statement",
        "Finder's Fee Agreement",
        "Franchise Agreement",
        "Framework Purchase Agreement",
        "GDPR Compliance Statement",
        "Health Information Privacy Notice",
        "Indemnity Agreement",
        "Independent Contractor Agreement",
        "Investment Prospectus",
        "Joint Venture Agreement",
        "Labour Regulations",
        "Landlord's Consent to Lease Assignment",
        "Letter of Intent",
        "Licensing Agreement",
        "Limited Partnership Agreement",
        "Loan Agreement",
        "Manufacturing Agreement",
        "Merger Agreement",
        "Mortgage Agreement",
        "Non-Compete Agreement",
        "Non-Disclosure Agreement",
        "Notice of Breach of Contract",
        "Offshore Contract",
        "Outsourcing Services Agreement",
        "Partnership Agreement",
        "Patent Statement",
        "Power of Attorney",
        "Prenuptial Agreement",
        "Privacy Policy",
        "Property Management Agreement",
        "Purchase Order",
        "Real Estate Purchase Agreement",
        "Release Agreement",
        "Residential Rental Agreement",
        "Revocable Living Trust",
        "Safe Harbor Statement",
        "Sale Contract",
        "Security Agreement",
        "Service Agreement",
        "Settlement Agreement",
        "Severance Agreement",
        "Share Purchase Agreement",
        "Shareholder Agreement",
        "Software Development Agreement",
        "Software License Agreement",
        "Sponsorship Agreement",
        "Stock Option Agreement",
        "Subcontractor Agreement",
        "Subscription Agreement",
        "Supply Agreement",
        "B2B Terms & Conditions",
        "B2C Terms & Conditions",
        "Terms of Service Agreement",
        "Trademark Notice",
        "Transport Contract",
        "User Agreement",
        "Warranty Agreement",
        "Will and Testament",
      ];
  
      const options = types?.map((type, index) => {
        return (
          <option 
            key={index}
            value={type}
          >
            {t(type)}
          </option>
        )
      }).sort((a, b) => {
        const textA = a.props.children;
        const textB = b.props.children;
        return textA.localeCompare(textB);
      });
      
      if(barebones) return (
        <div className="select selectType barebones">
          <div className="selectHolder">
            <span className="selection">{type || t('draft.chooseType')}</span>
            <select onChange={(e) => setType(e.target.value)} defaultValue={type || ""}>
              <option value="">{t('draft.chooseType')}</option>
              {options}
            </select>
          </div>
        </div>
      );
  
      return (
        <div className="select selectType">
          <h3>{t('analysis.settings_8')}</h3>
          <div className="selectHolder">
            <span className="selection">{t(type)}</span>
            <select onChange={(e) => setType(e.target.value)} defaultValue={type}>
              {options}
            </select>
          </div>
        </div>
      );
};

export default SelectType;